import type { Dtos, SuretyAccountId, SuretyBondId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useRequest } from "../../utils/request";
import { bondTermsQueryKey } from "./bond.keys";

export const useFetchBondTerms = (
	accountId: SuretyAccountId,
	bondId: SuretyBondId,
	enabled = true,
) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();
	const isAdmin = user.type === "admin";

	const { data, error, isLoading } = useQuery({
		queryKey: bondTermsQueryKey(bondId),
		queryFn: async () => {
			const url = isAdmin
				? `/v2/admin/surety/accounts/${accountId}/bonds/${bondId}/terms`
				: `/v2/surety/accounts/${accountId}/bonds/${bondId}/terms`;
			return await get<Dtos.SuretyBondTerm.Get.Response[]>(url);
		},
		enabled,
	});

	const terms = useMemo(() => data ?? [], [data]);

	return {
		terms,
		termsError: error,
		termsLoading: isLoading,
	};
};
